// extracted by mini-css-extract-plugin
module.exports = {"layout":"style_layout__0Ejwl","image":"style_image__s1iTs","content":"style_content__EuUTr","form":"style_form__cWpeA"};